// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2w9Ce","calendarButtons":"ClockData_calendarButtons__6bsLW"};